import { ControlType, LocalStorageKey } from "../../../../../../../models";
import { localStorage } from "../../../../../../../services";

export default {
  validate: control => {
    const currentData = localStorage.getItem(LocalStorageKey.savedForm);

    if (control.type == ControlType.multiFieldSelectorCb) {
      if (control.options[0].field == "validDataGuarantee") {
        return {
          required: true, 
          message: "Potvrdite ispravnost unešenih podataka."
        }
      }
    }
    if (control.condition && currentData) {
      if (currentData[control.condition]) {
        return {
          required: false
        };
      } else {
        return {
          required: true,
          message: "Molimo, unesite ovo polje!"
        };
      }
    } else {
      return {
        required: true,
        message: "Molimo, unesite ovo polje!"
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/GroupPage/GroupControls/Control/FormItem/ValidationRuleResolver/RequiredRuleValidator.ts